import Styles from './LabQuiz.module.scss';
import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Module import.
import axios from 'axios';
import { Tab, Tabs, Tooltip, Backdrop } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

// Components import.
import { useAPI, ViewContext } from 'components/lib';
import { QuizQuestion } from 'components/global/QuizQuestion/QuizQuestion';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

// Util import.
import { decoder } from 'utils/helpers/decoder';

export function LabQuiz(props) {

	const { lab_id } = useParams();
	const { job_id } = useParams();
	const { context } = useParams();

	const navigate = useNavigate();
	const viewContext = useContext(ViewContext);

	const [questions, setQuestions] = useState([]);
	const [selectedAnswers, setSelectedAnswers] = useState([]);
	const [tabIndex, setTabIndex] = useState(0);
	const [score, setScore] = useState(0);
	const [percentage, setPercentage] = useState(0);
	const [quizName, setQuizName] = useState('');
	const [apiURL, setAPIURL] = useState('');
	const [isResults, setIsResults] = useState(context === 'results');
	const [jobQuiz, setJobQuiz] = useState(context === 'hire')


	useEffect(() => {
		if (context === 'hire') {
			setJobQuiz(true)
			setAPIURL(`/api/hiring/jobs/quiz/${job_id}`);
		}
		if (context === 'results') {
			setIsResults(true);
			setAPIURL(`/api/labs/${lab_id}/quiz/results`);
		}
		if (context === 'attempt') {
			setAPIURL(`/api/labs/${lab_id}/quiz`);
		}
		if (context !== 'attempt' && context !== 'results' && context !== 'hire') {
			navigate('/404');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isResults]);

	const { data, loading } = useAPI(apiURL, 'GET');

	useEffect(() => {

		if (data?.length) {
			const jsonData = decoder(data);
			if (isResults) {
				setQuestions(jsonData[0].answers);
				setScore(jsonData[0].score.pop());
				setPercentage(jsonData[0].percentage);
			} else if (jobQuiz) {
				setQuestions(jsonData?.quiz);
				const newSelectedAnswers = Array.from({ length: jsonData?.quiz?.length }, () => -1);
				setSelectedAnswers(newSelectedAnswers);
			} else {
				setQuestions(jsonData.questions);
				const newSelectedAnswers = Array.from({ length: jsonData.questions.length }, () => -1);
				setSelectedAnswers(newSelectedAnswers);
			}
			setQuizName(jsonData.name);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const tabLabels = questions.map((_, index) => (
		<div id={`tabCircle-${index}`} key={index} className={Styles.tabCircle}>
			{index + 1}
		</div>
	));

	const handleTabChange = (event, newTabIndex) => {
		setTabIndex(newTabIndex);
	};

	const handleJobQuiz = (orderId, questId, selectedOption, question) => {
		setSelectedAnswers((prevSelectedAnswers) => {
			const updatedSelectedAnswers = [...prevSelectedAnswers];

			updatedSelectedAnswers[orderId] = {
				question: question,
				question_id: questId,
				selectedOption: selectedOption,
			};

			return updatedSelectedAnswers;
		});
	};

	const handleAnswerSelect = (orderId, questId, selectedOption) => {
		setSelectedAnswers((prevSelectedAnswers) => {
			const updatedSelectedAnswers = [...prevSelectedAnswers];

			updatedSelectedAnswers[orderId] = {
				question_id: questId,
				selectedOption: selectedOption,
			};

			return updatedSelectedAnswers;
		});
	};

	const handlePrevClick = () => {
		setTabIndex(tabIndex - 1);
	};

	const handleNextClick = () => {
		setTabIndex(tabIndex + 1);
	};

	const handleSubmit = () => {
		if (jobQuiz) {
			try {
				const options = {
					method: 'PATCH',
					url: `/api/job/${job_id}/quiz_answers`,
					headers: {
						accept: 'application/json'
					},
					data: {
						answers: selectedAnswers
					}
				}

				axios
					.request(options)
					.then(response => {
						if (response.status === 200) {
							viewContext.notification.show(response.data.message, 'success', true);
							navigate(`/hiring/jobs/applied/${job_id}`);
						} else {
							viewContext.notification.show(response.data.message, 'error', true);
						}
					})
					.catch((err) => {
						let status = err.response
						console.log('error', status)
						viewContext.notification.show(props.t('Labs.LabQuiz.notification'), 'error', true);
						// navigate('/oops');
					})
			} catch (error) {

			}

			return;
		}

		if (!isResults) {
			const formData = {
				answers: selectedAnswers,
			};
			const options = {
				method: 'POST',
				url: `/api/labs/${lab_id}/quiz/submit`,
				headers: {
					accept: 'application/json',
				},
				data: formData,
			};
			axios
				.request(options)
				.then(async function (response) {
					await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
					navigate(`/labs/${lab_id}/quiz/results`);
					setIsResults(true);
					// window.location.reload();
					// history.push(`/labs/${lab_id}/quiz/results`);
				})
				.catch((err) => {
					let status = err.response.status;
					console.log('error', status);
					navigate('/oops');
				});
		} else {
			navigate(`/labs/${lab_id}/nodes`);
		}
	};

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = props.t('Labs.LabQuiz.preventDefault.close');
		};

		const handleBackButton = (event) => {
			event.preventDefault();
			const confirmLeave = window.confirm(props.t('Labs.LabQuiz.preventDefault.back'));
			if (confirmLeave) {
				window.removeEventListener('beforeunload', handleBeforeUnload);
				window.history.back();
			} else {
				window.history.pushState(null, null, window.location.href)

			}
		};


		window.addEventListener('beforeunload', handleBeforeUnload);
		window.addEventListener('popstate', handleBackButton);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			window.removeEventListener('popstate', handleBackButton);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	//used to handle back button trigger of popstate
	useState(() => {
		window.history.pushState(null, null, window.location.href)
	}, [])


	const renderTime = ({ remainingTime }) => {
		if (remainingTime === 0) {
			return <div className="timer">{props.t('Labs.LabQuiz.late')}</div>;
		}
		const minutes = Math.floor(remainingTime / 60);
		const seconds = remainingTime % 60;
		const formattedMinutes = String(minutes).padStart(2, '0');
		const formattedSeconds = String(seconds).padStart(2, '0');
		return `${formattedMinutes}:${formattedSeconds}`;
	};

	return (
		<div className={Styles.CardContainer}>
			<Backdrop
				open={true}
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 9999,
				}}
			>
				<div className={Styles.QuizContainer}>
					<div className={Styles.title}>
						{quizName} {isResults ? props.t('Labs.LabQuiz.quiz.results') : props.t('Labs.LabQuiz.quiz.attempt')}
					</div>
					{isResults && (
						<div id="scorePercentContainer" className={Styles.scorePercentContainer}>
							<div id="scoreContainer" className={Styles.scoreContainer}>
								{props.t('Labs.LabQuiz.score', { score: score, total: questions.length })}
							</div>
							<div
								style={{
									color: percentage < 80 ? 'red' : 'green',
								}}
								className={Styles.percentContainer}
							>
								{props.t('Labs.LabQuiz.percentage', { percentage: percentage })}
							</div>
						</div>
					)}
					<div id="tabsTimerContainer" className={Styles.tabsTimerContainer}>
						{!isResults && (
							<div id="timerContainer" className={Styles.timerContainer}>
								<CountdownCircleTimer
									isPlaying
									duration={jobQuiz ? (questions?.length * 60) : 600}
									size={80}
									colors={['#004777', '#F7B801', '#A30000', '#A30000']}
									colorsTime={[360, 240, 120, 0]}
									onComplete={handleSubmit}
								>
									{renderTime}
								</CountdownCircleTimer>
							</div>
						)}
						<div id="tabsContainer" className={Styles.tabsContainer}>
							<Tabs
								value={tabIndex}
								onChange={handleTabChange}
								TabIndicatorProps={{
									sx: {
										backgroundColor: '#1e88e5',
										height: 3,
									},
								}}
								variant="scrollable"
								scrollButtons="auto"
								centered
							>
								{tabLabels.map((tablabel, index) => (
									<Tab
										id={`questionTabs-${index}`}
										label={
											<div
												id={`tabCircle-${index}`}
												key={index}
												className={Styles.tabCircle}
												style={
													!isResults
														? {
															backgroundColor: selectedAnswers[index] !== -1 ? '#4986d6' : '#f2f2f2',
															color:
																selectedAnswers[index] !== -1
																	? '#fff'
																	: !questions[index].isAttempted
																		? '#000'
																		: '#f2f2f2',
														}
														: {
															backgroundColor: !questions[index].isAttempted
																? '#f5f5f5'
																: questions[index].isCorrect
																	? '#18af89'
																	: '#dc6262 ',
															color: !questions[index].isAttempted ? '#000' : '#f2f2f2',
														}
												}
											>
												{index + 1}
											</div>
										}
										sx={{
											fontWeight: '600',
											'&.Mui-selected': {
												color: '#1e88e5',
											},
										}}
									/>
								))}
							</Tabs>
						</div>
					</div>
					{loading ? (
						<div>
							<LoadingBackdrop isOpen={true} />
						</div>
					) : questions.length > 0 ? (
						<QuizQuestion
							key={questions[tabIndex]}
							question={questions[tabIndex]}
							questionNumber={tabIndex + 1}
							onAnswerSelect={jobQuiz ? handleJobQuiz : handleAnswerSelect}
							selectedAnswers={selectedAnswers}
							Results={isResults}
						/>
					) : (
						props.t('Labs.LabQuiz.none')
					)}

					<div className={Styles.buttonContainer}>
						<span>
							<QuizButton
								onClick={handlePrevClick}
								condition={tabIndex === 0}
								buttonText={props.t('Labs.LabQuiz.button.prev')}
								showIcon={false}
								showResult={isResults}
							></QuizButton>
						</span>
						<span>
							<QuizButton
								onClick={handleNextClick}
								condition={tabIndex === tabLabels.length - 1}
								buttonText={props.t('Labs.LabQuiz.button.next')}
								showIcon={false}
								showResult={isResults}
							></QuizButton>
						</span>
						<Tooltip
							title={isResults ? props.t('Labs.LabQuiz.tooltip.results') : props.t('Labs.LabQuiz.tooltip.attempt')}
							arrow
							placement="bottom"
							PopperProps={{ style: { zIndex: 9999 } }}
						>
							<span>
								<QuizButton
									onClick={handleSubmit}
									condition={jobQuiz ? false : selectedAnswers.includes(-1) && !isResults}
									buttonText={isResults ? props.t('Labs.LabQuiz.button.back') : props.t('Labs.LabQuiz.button.submit')}
									showIcon={!isResults}
									showResult={isResults}
								></QuizButton>
							</span>
						</Tooltip>
					</div>
				</div>
			</Backdrop>
		</div>
	);
}

export const QuizButton = (props) => {
	return (
		<div className={Styles.navButtonContainer}>
			<button
				className={Styles.quizButton}
				color="primary"
				disabled={props.condition}
				onClick={props.onClick}
				showIcon={props.showIcon}
			>
				{props.showIcon && <AssignmentTurnedInIcon fontSize="small" sx={{ marginRight: '4px' }} />}
				{props.buttonText}
			</button>
		</div>
	);
};